<template>
  <g fill-rule="evenodd">
    <path
      d="M17.29 4.8l-1.32 3.96a2.4 2.4 0 01-2.28 1.64H7.75L5.6 4.8h11.69zM.8 1.6h.75c.66 0 1.26.4 1.5 1.03l3 7.8a2.4 2.4 0 00.35 4.77H16a.8.8 0 000-1.6H6.4a.8.8 0 010-1.6h7.3a4 4 0 003.8-2.74l1.66-5a.8.8 0 00-.76-1.06H4.98l-.44-1.15A3.22 3.22 0 001.55 0H.8a.8.8 0 000 1.6zM7.6 16.8a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4M13.2 16.8a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4"
    />
  </g>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "IAPManagerIcon",
});
</script>
